import React from 'react';
import './Legend.css';

const Legend = () => {
  return (
    <div className="map-legend">
      <div className="legend-title">Temperature (°C)</div>
      <div className="legend-scale">
        <div className="legend-row">
          <span style={{ background: "#2c7bb6" }}></span>
          <span className="legend-label">20–24</span>
        </div>
        <div className="legend-row">
          <span style={{ background: "#abd9e9" }}></span>
          <span className="legend-label">25–29</span>
        </div>
        <div className="legend-row">
          <span style={{ background: "#ffffbf" }}></span>
          <span className="legend-label">30–31</span>
        </div>
        <div className="legend-row">
          <span style={{ background: "#fee08b" }}></span>
          <span className="legend-label">32–33</span>
        </div>
        <div className="legend-row">
          <span style={{ background: "#fdae61" }}></span>
          <span className="legend-label">34–35</span>
        </div>
        <div className="legend-row">
          <span style={{ background: "#f46d43" }}></span>
          <span className="legend-label">36–37</span>
        </div>
        <div className="legend-row">
          <span style={{ background: "#d73027" }}></span>
          <span className="legend-label">38–39</span>
        </div>
        <div className="legend-row">
          <span style={{ background: "#a50026" }}></span>
          <span className="legend-label">40–44</span>
        </div>
        <div className="legend-row">
          <span style={{ background: "#6a000f" }}></span>
          <span className="legend-label">45+</span>
        </div>
      </div>
    </div>
  );
};

export default Legend;
